module.exports = __webpack_public_path__ + "img/2022.3.49255aed.jpg";